import FrameMessenger from 'frame-messenger';
import Browser from '../helpers/browser';

export default class FrameEventService {

  static sendBrickClicked(brickData) {
    FrameEventService.send(brickData, 'brick-clicked', {});
  }

  static sendSignInRequired(brickData) {
    FrameEventService.send(brickData, 'sign-in-required', {});
  }

  static sendTrailerClicked(brickData, options) {
    FrameEventService.send(brickData, 'trailer-clicked', options);
  }

  static sendFireTrackingEvent(brickData, options) {
    FrameEventService.send(brickData, 'fire-tracking-event', options);
  }

  static send(brickData, event, data) {
    const enrichedData = {
      ...data,
      brickId: brickData.brickId,
    };

    if (brickData.inWidget) {
      FrameMessenger.send(Browser.getWindow(), event, enrichedData, '*');
    } else {
      FrameMessenger.sendToParent(event, enrichedData);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/frame-event-service.js